import { ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { FIRM } from "../../lib/firm";
import { trackEvent } from "../../lib/analytics";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 overflow-hidden bg-cream"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-8 animate-fade-up">
              <span className="h-px w-10 bg-accent-gold" />
              <span
                className="text-xs tracking-overline uppercase font-semibold text-accent-gold"
                data-testid="hero-eyebrow"
              >
                A Boutique Family Office · McKinney, TX
              </span>
            </div>

            <h1
              className="font-serif font-light text-deep-teal leading-[1.02] tracking-tight animate-fade-up delay-100"
              style={{ fontSize: "clamp(2.5rem, 6.2vw, 5.25rem)" }}
              data-testid="hero-title"
            >
              We quantify what your retirement will cost in
              <span className="italic font-medium text-accent-gold"> taxes</span>
              <span className="text-deep-teal"> — then we reduce it.</span>
            </h1>

            <p
              className="mt-8 max-w-2xl text-lg text-charcoal-teal leading-relaxed animate-fade-up delay-200"
              data-testid="hero-subtitle"
            >
              Retirement Tax Consultants is the bridge between your CPA and
              your CFP — the retirement tax specialist neither one of them
              is.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-5 animate-fade-up delay-300">
              <a
                href={FIRM.calendly15}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  trackEvent("calendly_click_15min", {
                    meta: { source: "hero" },
                  })
                }
                data-testid="hero-book-15-btn"
                className="group inline-flex items-center gap-3 px-7 py-4 bg-accent-gold !text-white text-xs tracking-overline uppercase font-medium hover:bg-accent-gold-hover transition-all"
              >
                Schedule Your Risk Analysis
                <ArrowUpRight
                  size={16}
                  weight="light"
                  className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                />
              </a>
              <Link
                to="/services"
                data-testid="hero-learn-more-btn"
                className="inline-flex items-center gap-2 text-sm text-deep-teal editorial-link"
              >
                Learn how we work
                <ArrowUpRight size={16} weight="light" />
              </Link>
            </div>
          </div>

          <aside
            className="lg:col-span-4 relative animate-fade-in delay-500 lg:pl-8 lg:border-l lg:border-sage-soft"
            data-testid="hero-premise"
          >
            <div className="text-xs tracking-overline uppercase font-semibold text-accent-gold mb-5">
              The Premise
            </div>
            <p className="font-serif text-deep-teal text-2xl leading-snug">
              Most CPAs are focused on last year.
            </p>
            <p className="font-serif text-deep-teal text-2xl leading-snug mt-3">
              Most financial advisors are focused on growth.
            </p>
            <p className="mt-6 text-charcoal-teal text-base leading-relaxed">
              Neither one is focused exclusively on what happens to your
              wealth between now and the IRS. That is the gap Retirement Tax
              Consultants was built to fill.
            </p>
          </aside>
        </div>
      </div>

      <div className="pointer-events-none absolute top-1/3 -left-32 w-96 h-96 rounded-full bg-sage/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 w-[28rem] h-[28rem] rounded-full bg-accent-gold/5 blur-3xl" />
    </section>
  );
}
